export const postal = 'Your workplace postal code is only visible to you and is used to recommend CEBA events near your location.'

export const phone = 'Your personal phone number is only visible to you and can be used for you to opt-in to text reminders about our events.'

export const linkedIn = 'Your LinkedIn profile URL'

export const twitter = 'Your Twitter profile URL'

export const expandMessage = 'Click to expand message'

export const userSearch = 'Search for users by first name, last name, or the name of their organization'

export const orgRestrictions = 'This profile is private'

export const orgResourceLink = 'Link to external resource (e.g. http://www.example.com)'

export const orgResourceUpload = 'Directly upload a PDF from your machine'

export const genderPronouns = 'Your gender pronouns. This is optional and will only be displayed on your profile if you make a selection from the dropdown.'

export const orgResourceDisclaimer = 'CEBA seeks to facilitate easy access to relevant industry publications for our members’ convenience. Member-provided resources are wholly the property of the publishing entity, and any questions about their content should be directed accordingly. CEBA makes no assurances about the quality or accuracy of submitted member-provided resources. If you have concerns about a resource, please contact us via the messaging function at the bottom right corner of your screen. Accessing linked materials will open a separate tab outside of your CEBA InterConnect experience.'

export const orgPublishedResources = (
  isPublishable,
  publishedCount,
  publishedLimit,
  isCurrentlyPublished
) => {

  function resolvePlural() {
    return publishedCount === 1 ? 'resource' : 'resources'
  }

  if (publishedLimit === 'none') {
    return 'Drafts are only visible to members of this organization. Published resources are visible to everyone.'
  } else if (isPublishable && !isCurrentlyPublished) {
    return(
      `You currently have ${publishedCount} published ${resolvePlural()}. Your membership level allows ${publishedLimit} resources to be published at any given time.`
    )
  } else if (isCurrentlyPublished) {
    if (isPublishable) {
      return (
        `This resource is currently published. Your membership level allows you to publish ${publishedLimit - publishedCount} more ${resolvePlural()}.`
      )
    } else return(
      'This resource is currently published. Save as a draft to enable the publication of another resource.'
    )
  } else return(
    `This resource will be saved as a draft. You have reached your publication limit of ${publishedLimit} resources. If you wish to publish, please save a currently published resource as a draft.`
  )
}
